import {
  HOLIDAY_PARTY_2014_PHOTOS,
  FAMILY_JAMMING_2004_PHOTOS,
  JEFF_BOSINGER_MEMORIAL,
  BIKETOBER_FEST_2011,
  FIRE_HOGS_MEMORIAL,
  HOLIDAY_PARTY_2004_PHOTOS,
  OLD_SCHOOL_PHOTOS,
  HOLIDAY_PARTY_2005_PHOTOS,
  QUEENSBORO_2010,
  HOLIDAY_PARTY_2012,
  HOLIDAY_PARTY_2016,
  HOLIDAY_PARTY_2013,
  HOLIDAY_PARTY_2017,
  HOLIDAY_PARTY_2018,
  ANNIVERSARY_PHOTOS_10TH,
  HOLIDAY_PARTY_2019,
  BAKER_TRANS_DAY_PHOTOS,
  HOLIDAY_PARTY_2006,
  IRON_MAIDENS_2001_PHOTOS,
  HOLIDAY_PARTY_2015_PHOTOS,
  ANNIVERSARY_PHOTOS_20TH,
  IRON_MAIDENS_2004_PHOTOS,
} from './albumPhotos/index.js';

// This is where we store all the album details
const albumDetails = {
  'iron-maidens-2001': {
    name: 'Iron Maidens 2001',
    folder: 'IronMaidens2001',
    url: 'iron-maidens-2001',
    year: 2001,
    photoNames: IRON_MAIDENS_2001_PHOTOS,
  },
  'iron-maidens-2004': {
    name: 'Iron Maidens 2004',
    folder: 'IronMaidens2004',
    url: 'iron-maidens-2004',
    year: 2004,

    photoNames: IRON_MAIDENS_2004_PHOTOS,
  },
  //
  'baker-trans-day': {
    name: 'Baker Trans Day at Rolling Thunder',
    folder: 'BakerTransDay',
    url: 'baker-trans-day',
    year: 2004,
    photoNames: BAKER_TRANS_DAY_PHOTOS,
  },

  '20th-anniversary-party': {
    name: '20th Anniversary Party',
    folder: '20thAnniversaryParty',
    url: '20th-anniversary-party',
    year: 2004,
    photoNames: ANNIVERSARY_PHOTOS_20TH,
  },
  '10th-anniversary-party': {
    name: '10th Anniversary Party',
    folder: '10thAnniversaryParty',
    url: '10th-anniversary-party',
    year: 1994,
    photoNames: ANNIVERSARY_PHOTOS_10TH,
  },

  'holiday-party-2012': {
    name: 'Holiday Party 2012',
    folder: 'HolidayParty2012',
    url: 'holiday-party-2012',
    year: 2012,
    photoNames: HOLIDAY_PARTY_2012,
  },

  'holiday-party-2013': {
    name: 'Holiday Party 2013',
    folder: 'HolidayParty2013',
    url: 'holiday-party-2013',
    year: 2013,
    photoNames: HOLIDAY_PARTY_2013,
  },
  'holiday-party-2014': {
    name: 'Holiday Party 2014',
    folder: 'HolidayParty2014',
    url: 'holiday-party-2014',
    year: 2014,
    photoNames: HOLIDAY_PARTY_2014_PHOTOS,
  },
  'holiday-party-2005': {
    name: 'Holiday Party 2005',
    folder: 'HolidayParty2005',
    url: 'holiday-party-2005',
    year: 2005,
    photoNames: HOLIDAY_PARTY_2005_PHOTOS,
  },
  'holiday-party-2015': {
    name: 'Holiday Party 2015',
    folder: 'HolidayParty2015',
    url: 'holiday-party-2015',
    year: 2015,
    photoNames: HOLIDAY_PARTY_2015_PHOTOS,
  },
  'holiday-party-2016': {
    name: 'Holiday Party 2016',
    folder: 'HolidayParty2016',
    url: 'holiday-party-2016',
    year: 2016,
    photoNames: HOLIDAY_PARTY_2016,
  },
  'holiday-party-2017': {
    name: 'Holiday Party 2017',
    folder: 'HolidayParty2017',
    url: 'holiday-party-2017',
    year: 2017,
    photoNames: HOLIDAY_PARTY_2017,
  },
  'holiday-party-2018': {
    name: 'Holiday Party 2018',
    folder: 'HolidayParty2018',
    url: 'holiday-party-2018',
    year: 2018,
    photoNames: HOLIDAY_PARTY_2018,
  },
  'holiday-party-2019': {
    name: 'Holiday Party 2019',
    folder: 'HolidayParty2019',
    url: 'holiday-party-2019',
    year: 2019,
    photoNames: HOLIDAY_PARTY_2019,
  },
  'family-jamming-2004': {
    name: 'Family Jamming 2004',
    folder: 'FamilyJamming2004',
    url: 'family-jamming-2004',
    year: 2004,
    photoNames: FAMILY_JAMMING_2004_PHOTOS,
  },
  'holiday-party-2004': {
    name: 'Holiday Party 2004',
    folder: 'HolidayParty2004',
    url: 'holiday-party-2004',
    year: 2004,
    photoNames: HOLIDAY_PARTY_2004_PHOTOS,
  },
  'queensboro-2010': {
    name: 'Queensboro 2010',
    folder: 'Queensboro2010',
    url: 'queensboro-2010',
    year: 2010,
    photoNames: QUEENSBORO_2010,
  },

  'fire-hogs-memorial': {
    name: 'Fire Hogs 9.11.2011 Memorial',
    folder: 'FireHogsMemorial',
    url: 'fire-hogs-memorial',
    year: 2011,
    photoNames: FIRE_HOGS_MEMORIAL,
  },
  'jeff-bosinger-memorial': {
    name: "Jeff Bosinger Memorial Run '09-'13",
    folder: 'JeffBosingerMemorial',
    url: 'jeff-bosinger-memorial',
    year: 2013,
    photoNames: JEFF_BOSINGER_MEMORIAL,
  },
  'biketoberfest-2011': {
    name: 'Biketoberfest 2011',
    folder: 'Biketoberfest2011',
    url: 'biketoberfest-2011',
    year: 2011,
    photoNames: BIKETOBER_FEST_2011,
  },

  'old-school': {
    name: 'Old School',
    folder: 'OldSchool',
    url: 'old-school',
    year: 2004,
    photoNames: OLD_SCHOOL_PHOTOS,
  },

  'holiday-party-2006': {
    name: 'Holiday Party 2006',
    folder: 'HolidayParty2006',
    url: 'holiday-party-2006',
    year: 2006,
    photoNames: HOLIDAY_PARTY_2006,
  },
};

export const albumDetailsMap = Object.fromEntries(
  Object.entries(albumDetails).sort(([, a], [, b]) => {
    const yearA = a.year ?? Number.MAX_SAFE_INTEGER;
    const yearB = b.year ?? Number.MAX_SAFE_INTEGER;
    if (yearA !== yearB) return yearA - yearB;
    return a.name.localeCompare(b.name);
  })
);
